import { Link, useLocation } from 'react-router-dom';
import './AuthModeToggle.css';

interface Props {
  /** Which mode is currently active — drives the selected pill. */
  readonly current: 'signin' | 'signup';
}

/**
 * Segmented control pinned to the top of the auth panel that swaps between
 * the Create-account and Sign-in routes (the "single Create account / Sign in
 * page"). Implemented as <Link>s, not buttons, so each mode keeps its own
 * shareable URL and the back button behaves; the current `?next=` query is
 * carried across both tabs so an in-flight engage CTA (e.g. ?next=/agent/uno)
 * survives the toggle and still lands the user in that agent's console.
 *
 * Both routes render this same control, so toggling is an instant client-side
 * swap — the panel chrome stays put and only the title + form change.
 */
export default function AuthModeToggle({ current }: Props) {
  const { search } = useLocation();
  return (
    <div className="om-auth-toggle" role="tablist" aria-label="Account access">
      <Link
        to={{ pathname: '/auth/signup', search }}
        role="tab"
        aria-selected={current === 'signup'}
        className="om-auth-toggle__tab"
      >
        Create account
      </Link>
      <Link
        to={{ pathname: '/auth/signin', search }}
        role="tab"
        aria-selected={current === 'signin'}
        className="om-auth-toggle__tab"
      >
        Sign in
      </Link>
    </div>
  );
}
